import { createSelector } from 'reselect';

const selectParental = (state) => state.parental;

export const selectParentalData = createSelector(selectParental, (parental) => parental.data);

export const selectParentalError = createSelector(selectParental, (parental) => parental.error);

export const selectIsParentalControlEnabled = createSelector(selectParentalData, (data) => data.isParentalEnabled);

export const selectParentalControlAge = createSelector(selectParentalData, (data) => data.age);

export const selectParentalPin = createSelector(selectParentalData, (data) => data.pin);

export const selectIsPurchaseProtected = createSelector(selectParentalData, (data) => data.purchase);
